import { AppBar, AppBarProps } from '@mui/material'

type PlacementType = 'top' | 'bottom'

type MolsonAppBarProps = AppBarProps & {
  dataTestId?: string
  placement?: PlacementType
}

export const MolsonAppBar = ({
  dataTestId,
  placement,
  children,
  ...props
}: MolsonAppBarProps) => {
  let placementStyleObj = {}

  if (placement === 'top') {
    placementStyleObj = {
      position: 'sticky'
    }
  } else if (placement === 'bottom') {
    placementStyleObj = {
      position: 'fixed'
    }
  }

  return (
    <AppBar data-testid={dataTestId} {...placementStyleObj} {...props}>
      {children}
    </AppBar>
  )
}
